module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Copyright © 2000 by Fay Weldon")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by"), _c('br'), _vm._v("any electronic or mechanical means, including information storage and"), _c('br'), _vm._v("retrieval systems, without permission in writing from the publisher, except by"), _c('br'), _vm._v("a reviewer, who may quote brief passages in a review. Any members of"), _c('br'), _vm._v("educational institutions wishing to photocopy part or all of the work for"), _c('br'), _vm._v("classroom use, or publishers who would like to obtain permission to include"), _c('br'), _vm._v("the work in an anthology, should send their inquiries to Grove/Atlantic, Inc.,"), _c('br'), _vm._v("841 Broadway, New York, NY 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighta"
  }, [_vm._v("First published in 2000 by BVLGARI Italy S.p.A., Rome, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightb"
  }, [_vm._v("First published in Great Britain in 2001 by HarperCollins Publishers Ltd.,"), _c('br'), _vm._v("London, England")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FIRST GROVE PRESS EDITION")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Weldon, Fay."), _c('br'), _vm._v("     The Bulgari connection : a novel / by Fay Weldon."), _c('br'), _vm._v("            p. cm."), _c('br'), _vm._v("     eBook ISBN-13: 978-1-5558-4801-9"), _c('br'), _vm._v("     1. Rich people—Fiction. 2. Revenge—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("     PR6073.E374 B85 2001"), _c('br'), _vm._v("      823′.914—dc21             2001033294")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Design by FG confalonieri")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Grove Press"), _c('br'), _vm._v("841 Broadway"), _c('br'), _vm._v("New York, NY 10003")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 69
// module chunks = 0